import React from 'react';
import { Typography, Grid } from '@mui/material';
import img1 from '../../assets/doppler1.webp'


const CourseDetails = () => {
  return (
    <>
      <Grid
        container
        spacing={3}
        sx={{
          padding: { xs: '20px', sm: '30px', md: '40px' }, // Ajuste dinámico del padding
          maxWidth: '1200px', // Establece el ancho máximo
          mx: { xs: '', sm: '20px', md: 'auto' }, // Márgenes horizontales dinámicos
        }}
      >
        <Grid item xs={12} sm={6}>
          <img
            src={img1}
            alt="Programación Web"
            style={{
              width: '100%',
              borderRadius: '10px',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
              color: '#2c3e50',
              marginBottom: { xs: '10px', sm: '20px' },
              fontSize: { xs: '1.2rem', sm: '2rem' },
            }}
          >
            ¿Qué aprenderás?
          </Typography>
          <ul
            style={{
              fontSize: '0.9rem',
              color: '#7f8c8d',
              lineHeight: '1.5',
              marginBottom: '20px',
              paddingLeft: '20px',
            }}
          >
            <li>Principios básicos y avanzados de física y Doppler en ultrasonido ginecoobstétrico.</li>
            <li>Fundamentos de ginecología y su aplicación en ultrasonografía.</li>
            <li>Técnicas de ecografía de tamizaje en el primer y segundo trimestre del embarazo.</li>
            <li>Evaluación de la circulación feto-placentaria utilizando Doppler avanzado.</li>
            <li>Identificación y manejo de patologías como restricción del crecimiento intrauterino (RCIU) y anemia fetal.</li>
            <li>Diagnóstico y manejo de diversas cardiopatías fetales, incluyendo anomalías estructurales y funcionales.</li>
          </ul>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
              color: '#2c3e50',
              marginBottom: { xs: '10px', sm: '20px' },
              fontSize: { xs: '1.2rem', sm: '2rem' },
            }}
          >
            Requisitos
          </Typography>
          <ul
            style={{
              fontSize: '0.9rem',
              color: '#7f8c8d',
              lineHeight: '1.5',
              marginBottom: '20px',
              paddingLeft: '20px',
            }}
          >
            <li>Tener acreditado "DIPLOMADO BASICO EN ULTRASONIDO DIAGNOSTICO PARA MEDICOS GENERALES Y DIVERSOS ESPECIALISTAS"</li>
          </ul>
        </Grid>
      </Grid>
    </>
  );
};

export default CourseDetails;